import React, { useState } from 'react'

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormGroup,
  TextareaAutosize,
  Typography,
} from '@material-ui/core'

import useStyles from './products.styles'

const ProductRejectConfirmation = ({ open, handleClose, onConfirm, productsLength }) => {
  const classes = useStyles()
  const [rejectText, setRejectText] = useState('')
  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle id="alert-dialog-title">{`¿Está seguro que desea rechazar ${productsLength} productos?`}</DialogTitle>
      <DialogContent>
        <Typography variant="h6">Escribe el por que:</Typography>
        <FormGroup>
          <TextareaAutosize
            id="description"
            inputProps={{ maxLength: 250 }}
            maxRows={3}
            onChange={(e) => setRejectText(e.target.value)}
            className={classes.descriptionInfoBasic}
          />
        </FormGroup>
        <Typography variant="body1">Recuerda que son máximo 250 caracteres</Typography>
      </DialogContent>
      <DialogActions className={classes.groupButton}>
        <Button className={classes.btnBackgroundError} onClick={handleClose}>
          Cancelar
        </Button>
        <Button
          className={classes.btnBackgroundPrimary}
          variant="contained"
          color="secondary"
          autoFocus
          onClick={() => {
            onConfirm(rejectText)
          }}
        >
          Aceptar
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default ProductRejectConfirmation
